export default Object.freeze({
	AddFunds: 'add_funds',
	AllowNineDigitBarcode: 'allow_nine_digit_barcode',
	AlwaysIncludeDefaultImgOnShippingLabels:
		'always_include_default_img_on_shipping_labels',
	AutoPickupUsps: 'auto_pickup_usps',
	BrandedEmails: 'branded_emails',
	BrandedExternalPrints: 'branded_external_prints',
	BrandedTracking: 'branded_tracking',
	BrandedTrackingSms: 'branded_tracking_sms',
	BypassDomesticCustoms: 'bypass_domestic_customs',
	CanadaPost: 'canada_post',
	CanUseBasicLabelDesign: 'basic_label_design',
	CanUseMultiAddressPrinting: 'multi_address_printing',
	CanUseOrders: 'orders',
	CanUseProducts: 'products',
	CanUseSchedulePickup: 'schedule_pickup',
	CertifiedMail: 'certified_mail',
	ChangePaymentType: 'change_payment_type',
	ChangeServicePlan: 'change_service_plan',
	CleanseIntlAddress: 'cleanse_intl_address',
	CostCodes: 'cost_codes',
	CreateCriticalMail: 'create_critical_mail',
	DelayedManifesting: 'delayed_manifesting',
	DeliveryDutyPaid: 'delivery_duty_paid',
	DhlEcommerce: 'dhl_ecommerce',
	DhlExpress: 'dhl_express',
	DhlExpressPayOnUse: 'dhl_express_pay_on_use',
	DisableConversionToken: 'disable_conversion_token',
	EligibleForFcGap: 'eligible_for_fc_gap',
	EligibleForFciGap: 'eligible_for_fci_gap',
	EligibleForIntlGapSinglePiece: 'eligible_for_intl_gap_single_piece',
	EligibleForPmeiGap: 'eligible_for_pmei_gap',
	EligibleForPmiGap: 'eligible_for_pmi_gap',
	EligibleForPsGap: 'eligible_for_ps_gap',
	EmailNotifications: 'email_notifications',
	Envelopes: 'envelopes',
	Fba: 'fba',
	FcGap: 'fc_gap',
	FcmiFlatDelCon: 'fcmi_flat_del_con',
	Fedex: 'fedex',
	FedexPayOnUse: 'fedex_pay_on_use',
	GapPayOnUse: 'gap_pay_on_use',
	Globalpost: 'globalpost',
	GlobalPostPlus: 'global_post_plus',
	GlobalPostPostal: 'global_post_postal',
	GlobalPostDomestic: 'globalpost_domestic',
	GpPayOnUse: 'globalpost_pay_on_use',
	GpShipToConsolidator: 'globalpost_ship_to_consolidator',
	GpSmartSaver: 'gp_smart_saver',
	GpSmartSaverPayOnUse: 'globalpost_smart_saver_pay_on_use',
	HiddenPostage: 'hidden_postage',
	HistoryReturnLabel: 'history_return_label',
	Instalabel: 'instalabel',
	International: 'international',
	IntlGapSinglePiece: 'intl_gap_single_piece',
	Invoicing: 'invoicing',
	LabelLogo: 'label_logo',
	MailingLabel: 'mailing_label',
	Mcw: 'mcw',
	MemoOnShippingLabel: 'memo_on_shipping_label',
	NetStamps: 'net_stamps',
	Odbc: 'odbc',
	ParcelGuardInsurance: 'parcel_guard_insurance',
	Pmeod: 'pmeod',
	Pmod: 'pmod',
	PostalOverride: 'postal_override',
	Ppl: 'ppl',
	PsGap: 'ps_gap',
	Pslw: 'pslw',
	RetailGround: 'retail_ground',
	ReturnShippingLabel: 'return_shipping_label',
	RefundAssist: 'refundassist',
	RefundAssistEnabled: 'refundassistenabled',
	Scanform: 'scanform',
	Shipping: 'shipping',
	StampsComInsurance: 'stamps_com_insurance',
	StandaloneUspsReturn: 'standalone_usps_return',
	UnfundedIndicium: 'unfunded_indicium',
	Ups: 'ups',
	UpsGroundSaver: 'ups_ground_saver',
	UpsIntl: 'ups_intl',
	UpsPayOnUseReturns: 'ups_pay_on_use_returns',
	UpsReturns: 'ups_returns',
	UpsStandalonePayOnUseReturns: 'ups_standalone_pay_on_use_returns',
	Usps: 'usps',
	UspsMposLabel: 'usps_mpos_label',
	UspsReturn: 'usps_return',
	UspsReturnService: 'usps_return_service',
	UspsReturnServicePrepaid: 'usps_return_service_prepaid',
	AccessPilotSuppliesStore: 'access_pilot_supplies_store',
});
